import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import "./DeclineConfirmationPopup.css";
import { useTranslation } from "react-i18next";

function DeclineConfirmationPopup(props) {
  const { open, handleClose, declineConsentButtonName } = props;
  const { t } = useTranslation();

  const returnConsentTitle = () => {
    const eConsentArr = ["eConsent", "EConsentAgreement"];
    const authConsentArr = [
      "borrowerCertificationAuthorizationConsent",
      "Borrower's Certification & Authorization",
      "Borrower Authorization Consent",
    ];
    const creditConsentArr=["Consumer Credit Consent", "ConsumerConsent"]
    if( eConsentArr.includes(declineConsentButtonName)) {
        return t("e-Consent");
    } else if(authConsentArr.includes(declineConsentButtonName)) {
        return t("Borrower's Certification & Authorization");
    } else if(creditConsentArr.includes(declineConsentButtonName)) {
        return t("Credit Consent");
    }
  }
  return (
    <Dialog
      open={open}
      //   onClose={() => handleClose("Cancel")}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth="xs"
    >
      <DialogTitle
        id="alert-dialog-title"
        style={{
          backgroundColor: "#00634a",
          padding: "10px",
        }}
      >
        <span style={{ color: "white" }}>
          {returnConsentTitle()} {t("Decline Confirmation")}
        </span>
      </DialogTitle>
      <DialogContent
        style={{
          paddingTop: "20px",
        }}
      >
        {t("Are you sure you want to decline the")} {returnConsentTitle()}?
      </DialogContent>
      <DialogActions>
        <button
          onClick={() => handleClose("Confirm")}
          className="confirm-button"
          autoFocus
        >
            {t("Yes")}
        </button>
        <button onClick={() => handleClose("Cancel")} className="cancel-button">
            {t("No")}
        </button>
      </DialogActions>
    </Dialog>
  );
}
export default DeclineConfirmationPopup;
